import React from 'react';
import ProcessingTimeline from './ProcessingTimeline';

const ProcessingSidebar = ({
  className = '',
  loadingSteps,
  isUploading,
  isProcessingFinished,
  downloadToken,
  selectedFile,
  handleDownloadVideo,
  buttonText,
  countdown,
  formatCountdown,
}) => {
  return (
    <aside className={`min-w-0 2xl:sticky 2xl:top-6 2xl:self-start ${className}`}>
      <ProcessingTimeline
        loadingSteps={loadingSteps}
        isUploading={isUploading}
        isProcessingFinished={isProcessingFinished}
        downloadToken={downloadToken}
        selectedFile={selectedFile}
        handleDownloadVideo={handleDownloadVideo}
        buttonText={buttonText}
        countdown={countdown}
        formatCountdown={formatCountdown}
      />
    </aside>
  );
};

export default ProcessingSidebar;